import { render, staticRenderFns } from "./Canvasser.vue?vue&type=template&id=259df082&"
import script from "./Canvasser.vue?vue&type=script&lang=js&"
export * from "./Canvasser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports